import { ProgressBar } from "../../ProgressBar/ProgressBar"
import { VideoProgressBar } from "./VideoProgressBar";
import PlayIcon from '../../../public/images/icons/video/play.svg';
import PauseIcon from '../../../public/images/icons/video/pause.svg';
import QualityIcon from '../../../public/images/icons/video/video-quality.svg';
import MaximizeIcon from '../../../public/images/icons/video/maximize.svg';
import NoSoundIcon from '../../../public/images/icons/video/mute.svg';
import SoundIcon from '../../../public/images/icons/video/unmute.svg';
import cls from 'clsx';
import { useContext, useEffect } from "react";
import { VideoPlayerContext } from "./VideoPlayerContext";

export const VideoControls = ({ fullScreenHandle }: any) => {
    const { loaded, playing, setPlaying, quality, setQuality, muted, adActive,
         setMuted, hidden, showControls, videoRef } = useContext(VideoPlayerContext);

    const fullScreen = () => {
        const el = videoRef.current;

        if (!el.requestFullscreen && el.webkitEnterFullScreen) {
            el.webkitEnterFullScreen();
            return;
        }
        
        if (fullScreenHandle.active) {
            fullScreenHandle.exit();
        }
        else {
            fullScreenHandle.enter();
        }
    }

    return (
        <div onMouseMove={() => showControls()} className={cls("absolute bottom-0 w-full h-[64px] px-[4px]", {
            ["opacity-0"]: playing && hidden || !loaded
        })} style={{
            background: 'linear-gradient(0deg,#000,transparent)',
            transition: 'opacity .2s ease-in'
        }}>
            <VideoProgressBar />
            <div className="flex h-[24px] mx-[8px]">
                {!playing &&
                    <button onClick={() => setPlaying(true)} className="block">
                    <PlayIcon className="w-6 h-6 text-white" />
                    </button>
                }
                {playing &&
                    <button onClick={() => setPlaying(false)} className="block">
                    <PauseIcon className="w-6 h-6 text-white" />
                    </button>
                }
                <div className="flex-1 flex justify-end gap-x-6">
                    {!adActive &&
                        <button onClick={() => setQuality(quality === 'sd' ? 'hd' : 'sd')} className="block relative">
                            <QualityIcon className="w-6 h-6 text-white" />
                            <span style={{
                                background: 'linear-gradient(93.75deg,#e5194d,#8c18f1)',
                                borderRadius: '8px',
                                padding: '2px 3px',
                                fontSize: '.625rem',
                                lineHeight: '.625rem',
                                position: 'absolute',
                                bottom: '1px',
                                right: '-12px'
                            }}>{quality === 'hd' ? 'HD' : 'SD'}</span>
                        </button>
                    }
                    <button onClick={fullScreen} className="block">
                        <MaximizeIcon className="w-6 h-6 text-white" />
                    </button>

                    {muted &&
                        <button onClick={() => setMuted(false)} className="block">
                            <NoSoundIcon className="w-6 h-6 text-white" />
                        </button>
                    }
                    {!muted &&
                        <button onClick={() => setMuted(true)} className="block">
                            <SoundIcon className="w-6 h-6 text-white" />
                        </button>
                    }
                </div>
            </div>
        </div>
    )
}